var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        {
          class: [{ "has-danger": _vm.errors.has("person_type") }, "col-lg-3"]
        },
        [
          _c("label", { attrs: { for: "person_type" } }, [
            _vm._v(
              _vm._s(_vm._f("capitalize")(_vm._f("translate")("person_type")))
            )
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.person_type,
                  expression: "person_type"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              class: {
                "form-control": true,
                error: _vm.errors.has("person_type")
              },
              attrs: { name: "person_type", id: "person_type" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.person_type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(_vm._s(_vm._f("capitalize")("select_an_option")))
              ]),
              _vm._v(" "),
              _vm._l(
                _vm.report_type === 2 ? _vm.person_types : _vm.person_types_by,
                function(person_type, key) {
                  return _c(
                    "option",
                    { key: key, domProps: { value: person_type.value } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm._f("translate")(person_type.name)
                          )
                        )
                      )
                    ]
                  )
                }
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("person_type"),
                  expression: "errors.has('person_type')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [_vm._v(" " + _vm._s(_vm.errors.first("person_type")) + " ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            { "has-danger": _vm.errors.has("identification_number") },
            "col-lg-3"
          ]
        },
        [
          _c("label", { attrs: { for: "identification_number" } }, [
            _vm._v(
              _vm._s(
                _vm._f("capitalize")(
                  _vm._f("translate")("identification_number")
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.identification_number,
                expression: "identification_number"
              },
              {
                name: "validate",
                rawName: "v-validate",
                value:
                  _vm.report_type === 7 || _vm.report_type === 14
                    ? "required|numeric|min:4|max:12"
                    : "numeric|min:4|max:12",
                expression:
                  "report_type === 7 || report_type === 14 ? 'required|numeric|min:4|max:12' : 'numeric|min:4|max:12' "
              }
            ],
            staticClass: "form-control form-control-danger m-input",
            attrs: { type: "text", name: "identification_number" },
            domProps: { value: _vm.identification_number },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.identification_number = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("identification_number"),
                  expression: "errors.has('identification_number')"
                }
              ],
              staticClass: "m-form__help m--font-danger"
            },
            [
              _vm._v(
                " " + _vm._s(_vm.errors.first("identification_number")) + " "
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group m-form__group row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12", staticStyle: { "text-align": "right" } },
        [
          _c("label", { attrs: { for: "" } }, [_vm._v(" ")]),
          _c("br"),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-success m-btn m-btn--icon",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.generateReport()
                }
              }
            },
            [
              _c("span", [
                _c("i", { staticClass: "la la-archive" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm._f("capitalize")(
                        _vm._f("translate")("generate_report")
                      )
                    )
                  )
                ])
              ])
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cd726fa", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd726fa","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/reports/forms/AuthorizedByPersonForm.vue
// module id = 525
// module chunks = 0 1 4 47